// extracted by mini-css-extract-plugin
export default {"error":"error_error__IGiuL","backHome":"error_backHome__cu6yt"};